import React from 'react'
import styled from 'styled-components'

// Typography
import { H1 } from './Typography/Components/Headings/H1'
import { Text } from './Typography/Components/Text/Text'

// Colors
import colors from '../_constants/colors'

const StyledOriginateFormHeader = styled.header`
  margin-bottom: 20px;

  .sub-title {
    opacity: 0.5;
    margin: 3px 0 0;
  }
`

export const OriginateFormHeader = ({ title, subtitle = null }) => {
  return (
    <StyledOriginateFormHeader>
      <H1>{title}</H1>
      <Text fs={'16px'} textColor={colors.SUBTITLE_GREY}>
        {subtitle}
      </Text>
    </StyledOriginateFormHeader>
  )
}
